/**
 * Enum para almacenar los filtros posibles para buscar ventas
 * Pueden ser:
 * - Ultima hora (LastHour)
 * - Hoy (Today)
 * - Esta semana (ThisWeek)
 * - En cualquier momento (AnyTime)
 */
export enum SalesDateFilter {
	LastHour,
	Today,
	ThisWeek,
	AnyTime,
	NotSync
}

/**
 * Enum para almacenar los filtros posibles de estado de la sincronizacion
 * Pueden ser:
 * - No sincronizados (NotSync)
 * - Sincronizados (Sync)
 * - Todos  (All)
 */
export enum SalesSyncFilter {
	NotSync,
	Sync,
	All
}

/**
 * Enum para identificar los tipos de pago.
 */
export enum PaymentType {
	Cash,
	Credit
}

/**
 * Enum para identificar los lugares de los descuentos (desc1, desc2, etc)
 */
export enum DiscountNumber {
	One,
	Two,
	Three,
	Four
}
